type ResizeCallback = (width: number) => void;

let observer: ResizeObserver | null = null;
const subscribers = new Set<ResizeCallback>();

/**
 * Subscribes to document resize changes using a shared singleton ResizeObserver.
 */
export function subscribeToResize(callback: ResizeCallback) {
  subscribers.add(callback);

  // Lazily initialize observer only once
  if (!observer) {
    observer = new ResizeObserver((entries) => {
      const { width } = entries[0].contentRect;
      subscribers.forEach((cb) => cb(width));
    });
    observer.observe(document.documentElement);
  }

  return () => {
    subscribers.delete(callback);
    // Optionally disconnect if no subscribers left
    if (subscribers.size === 0 && observer) {
      observer.disconnect();
      observer = null;
    }
  };
}
